import React from 'react'
import Header from '../Header/Header'

export default function StaffAugmentation() {
  return (
    <>
    <Header isActive={"Services"}/>
   <div id="content" class="site-content">
      <div className="page-header dtable text-center" style={{ backgroundImage: 'url(resources/images/banner-.jpg)' }}>
   <div className="dcell">
      <div className="container">
         <h1 className="page-title">Software Development</h1>
      </div>
   </div>
</div>
<section className="p-b110">
   <div className="container">
      <div className="flex-row">
         <div className="services-left-1">
            <img src="resources/images/img-services-1.png" alt="" />
         </div>
         <div className="services-right-1 align-self-center">
            <div className="ot-heading">
               <h6><span>Software Development</span></h6>
               <h2 className="main-heading">Custom Software Development with Humanix Technologies</h2>
            </div>
            <p className="m-b50">At Humanix Technologies, we design and build custom software that takes you from concept to deployment, helping businesses turn ideas into scalable, production-ready products. Our development process is flexible, transparent, and tailored to align seamlessly with your specific business objectives.
As a trusted software development partner, we ensure complete peace of mind through disciplined engineering practices and close collaboration at every stage. Our experienced developers and architects are ready to address your project requirements, delivering modern, maintainable applications across diverse domains to drive your success. Partner with Humanix Technologies for scalable, reliable, and expert-driven software development.</p>
            <div className="row">
               <div className="col-md-4 col-sm-6 col-xs-6 xs-text-center sm-m-b40">
                  <div className="ot-counter s3">
                     <div>
                        <span className="num" data-to="100" data-time="2000">0</span>
                        <span>+</span>
                     </div>
                     <h6>Active Developers</h6>
                  </div>
               </div>
               <div className="col-md-4 col-sm-6 col-xs-6 xs-text-center sm-m-b40 xs-m-b40">
                  <div className="ot-counter s3">
                     <div>
                        <span className="num" data-to="30" data-time="2000">0</span>
                        <span>+</span>
                     </div>
                     <h6>Satisfied Clients</h6>
                  </div>
               </div>
               <div className="col-md-4 col-sm-6 col-xs-6 xs-text-center sm-m-b40">
                  <div className="ot-counter s3">
                     <div>
                        <span className="num" data-to="50" data-time="2000">0</span>
                        <span>+</span>
                     </div>
                     <h6>Innovative Solutions Delivered</h6>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>

<section className="p-t110 p-b50">
   <div className="container">
      <div className="row">
         <h1>What You Will Gain</h1>
         <div className="col-md-6 col-sm-12 col-xs-12 sm-m-b40">
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">01</span>
               <div className="number-box">01</div>
               <div className="content-box">
                  <h5>End-to-End Development</h5>
                  <p>From requirements and architecture to deployment and support, we own the full software development lifecycle for your product.</p>
               </div>
            </div>
            <div className="service-box s-box">
               <div className="overlay"></div>
               <span className="big-number">02</span>
               <div className="number-box">02</div>
               <div className="content-box">
                  <h5>Custom-Built Applications</h5>
                  <p>Get software engineered around your exact workflows and business logic, not a one-size-fits-all template.</p>
               </div>
            </div>
         </div>
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">03</span>
               <div className="number-box">03</div>
               <div className="content-box">
                  <h5>Scalable Architecture</h5>
                  <p>We build on modern, modular architectures designed to scale with your user base and evolve with your roadmap.</p>
               </div>
            </div>
            <div className="service-box s-box">
               <div className="overlay"></div>
               <span className="big-number">04</span>
               <div className="number-box">04</div>
               <div className="content-box">
                  <h5>Agile Delivery</h5>
                  <p>Iterative sprints with regular demos keep you in the loop and let us adapt quickly as requirements evolve.</p>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>

<section className="p-t110 p-b50">
   <div className="container">
      <div className="row">
         <h1>Our Development Team</h1>
         <div className="col-md-6 col-sm-12 col-xs-12 sm-m-b40">
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">01</span>
               <div className="number-box">01</div>
               <div className="content-box">
                  <h5>Frontend Developers</h5>
               </div>
            </div>
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">03</span>
               <div className="number-box">03</div>
               <div className="content-box">
                  <h5>UI/UX Designers</h5>
               </div>
            </div>
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">05</span>
               <div className="number-box">05</div>
               <div className="content-box">
                  <h5>Business Analysts</h5>
               </div>
            </div>
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">07</span>
               <div className="number-box">07</div>
               <div className="content-box">
                  <h5>Cloud Developers</h5>
               </div>
            </div>
            <div className="service-box s-box">
               <div className="overlay"></div>
               <span className="big-number">09</span>
               <div className="number-box">09</div>
               <div className="content-box">
                  <h5>AI/ML Engineers</h5>
               </div>
            </div>
         </div>
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">02</span>
               <div className="number-box">02</div>
               <div className="content-box">
                  <h5>Backend Developers</h5>
               </div>
            </div>
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">04</span>
               <div className="number-box">04</div>
               <div className="content-box">
                  <h5>Project Manager</h5>
               </div>
            </div>
            
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">06</span>
               <div className="number-box">06</div>
               <div className="content-box">
                  <h5>DevOps Engineers</h5>
               </div>
            </div>
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">08</span>
               <div className="number-box">08</div>
               <div className="content-box">
                  <h5>QA & Test automation engineers</h5>
               </div>
            </div>
            <div className="service-box s-box">
               <div className="overlay"></div>
               <span className="big-number">10</span>
               <div className="number-box">10</div>
               <div className="content-box">
                  <h5>Data Engineers</h5>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>

<section className="container">
   <div className="p-t120">
      <div className="row flex-row align-items-end">
         <div className="col-lg-6 col-md-12 col-xs-12 xs-m-b40">
            <div className="ot-heading">
               <h2 className="main-heading">Here to Help Your Every Business Need</h2>
            </div>
            <div className="ot-accordions">
               <div className="acc-item current">
                  <div className="acc-content active" style={{ display: 'block' }}>
                  We specialize in building custom software, enabling you to focus on driving your business forward.
Let us handle your product development by turning your requirements into a working, scalable application.
Explore how our developers and architects can take your idea from concept to deployment with modern, maintainable code.
Partner with us to unlock the full potential of your projects through flexible, expert-driven software development.
We're here to provide the expertise you need, ensuring your product remains reliable, scalable, and competitive.
Discover how our software development services can elevate your business—start today!</div>
               </div>
            </div>
         </div>
         <div className="col-lg-6 col-md-12 col-xs-12 text-center">
            <img src="resources/images/img.png" alt="seo" />
         </div>
      </div>
   </div>
</section>

{/* <section className="p-t100 p-b50">
  <div className="container">
    <div className="row">
      <h1>Curriculum</h1>
      <div className="col-md-6 col-xs-12 sm-m-b40">
        <div className="ot-accordions">
          <div className="acc-item current">
            <span className="acc-toggle">
              Level -1
              <i className="down flaticon-arrow-pointing-to-down"></i>
              <i className="up flaticon-arrow-pointing-to-up"></i>
            </span>
            <div className="acc-content active" style={{ display: 'block' }}>
              <h6>Programming Fundamentals</h6>
              <div className="row">
                <div className="col-xs-4">6 Weeks</div>
                <div className="col-xs-4">1 Guest Lecture</div>
                <div className="col-xs-4">2 Contests</div>
              </div>
              This module will help beginners to get familiar with programming
            </div>
          </div>
          <div className="acc-item">
            <span className="acc-toggle">
              Level -2
              <i className="down flaticon-arrow-pointing-to-down"></i>
              <i className="up flaticon-arrow-pointing-to-up"></i>
            </span>
            <div className="acc-content">
              <h6>Building an E-Commerce Website</h6>
              <div className="row">
                <div className="col-xs-6">6 Weeks</div>
                <div className="col-xs-6">1 Guest Lecture</div>
              </div>
              <p>
                Understand the core fundamentals of site building from industry experts and build an E-commerce website.
                Learning is meaningful when you can apply the concepts and solve real-world problems. We will explore this
                possibility in this module.
              </p>
            </div>
          </div>
          <div className="acc-item">
            <span className="acc-toggle">
              Level -3
              <i className="down flaticon-arrow-pointing-to-down"></i>
              <i className="up flaticon-arrow-pointing-to-up"></i>
            </span>
            <div className="acc-content">
              <h6>Data Structures and Algorithms</h6>
              <div className="row">
                <div className="col-xs-6">6 Weeks</div>
                <div className="col-xs-6">1 Guest Lecture</div>
              </div>
              <p>
                Now that we have a fair idea about HTML, CSS, and React, let's enhance our problem-solving skills further
                by learning the intermediate and advanced concepts of Data Structures and Algorithms. In this module, we will
                extensively focus on problem-solving.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-xs-12">
        <div className="ot-accordions accordions-gradient">
          <div className="acc-item current">
            <span className="acc-toggle">
              Level -4
              <i className="down flaticon-arrow-pointing-to-down"></i>
              <i className="up flaticon-arrow-pointing-to-up"></i>
            </span>
            <div className="acc-content active" style={{ display: 'block' }}>
              <h6>Building a CRM App</h6>
              <div className="row">
                <div className="col-xs-6">5 Weeks</div>
                <div className="col-xs-6">1 Contest</div>
              </div>
              <p>
                Build the frontend to run a CRM app that will help you manage all your business leads at one place and provide a complete picture of all customer interactions.
              </p>
            </div>
          </div>
          <div className="acc-item">
            <span className="acc-toggle">
              Level -5
              <i className="down flaticon-arrow-pointing-to-down"></i>
              <i className="up flaticon-arrow-pointing-to-up"></i>
            </span>
            <div className="acc-content">
              <h6>Building a Movie Booking App</h6>
              <div className="row">
                <div className="col-xs-6">4 Weeks</div>
                <div className="col-xs-6">1 Contest</div>
              </div>
              <p>
                Build a website in which users can book a movie, a match, or any event of their choice at a location and price suitable for them.
              </p>
            </div>
          </div>
          <div className="acc-item">
            <span className="acc-toggle">
              Level -6
              <i className="down flaticon-arrow-pointing-to-down"></i>
              <i className="up flaticon-arrow-pointing-to-up"></i>
            </span>
            <div className="acc-content">
              <h6>Interview Practice</h6>
              <div className="row">
                <div className="col-xs-6">4 Weeks</div>
                <div className="col-xs-6">1 Contest</div>
              </div>
              <p>Solve sample test questions and get ready to ace the interviews.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="p-t120 p-b50 bg-pricing">
  <div className="container">
    <div className="ot-heading text-center">
      <h2 className="main-heading">Pricing Details</h2>
    </div>
    <div className="row">
      <div className="col-md-4 sm-p-b60"></div>
      <div className="col-md-4 sm-p-b60">
        <div className="ot-pricing-table bg-shape s2">
          <span className="title-table">10% Discount</span>
          <div className="inner-table sm-p-t60">
            <img src="resources/images/price2-1.png" alt="Economy" />
            <h6>
              <s>
                <sup>₹</sup> 35000
              </s>
            </h6>
            <h2>
              <sup>₹</sup> 31500
            </h2>
            <div className="details">
              <ul>
                <li>Course Duration 6 Months</li>
                <li>Top Companies Preparation</li>
                <li>8.4L Average CTC offered</li>
                <li>9 Days Placement time</li>
                <li>Upto 350% Salary hike</li>
              </ul>
            </div>
          </div>
          <a href="contact.html" className="octf-btn octf-btn-icon octf-btn-third">
            ENROLL NOW <i className="flaticon-right-arrow-1"></i>
          </a>
        </div>
      </div>
      <div className="col-md-4"></div>
    </div>
  </div>
</section>

<section className="p-b420">
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <div className="partners">
          <div className="owl-carousel home-client-carousel">
            <div className="partners-slide">
              <a href="#" className="client-logo">
                <figure className="partners-slide-inner">
                  <img className="partners-slide-image" src="resources/images/brands/zoomcar-4.webp" alt="" />
                </figure>
              </a>
            </div>
            <div className="partners-slide">
              <a href="#" className="client-logo">
                <figure className="partners-slide-inner">
                  <img className="partners-slide-image" src="resources/images/brands/zoomcar-10.webp" alt="" />
                </figure>
              </a>
            </div>
            <div className="partners-slide">
              <a href="#" className="client-logo">
                <figure className="partners-slide-inner">
                  <img className="partners-slide-image" src="resources/images/brands/rakuten.png" alt="" />
                </figure>
              </a>
            </div>
            <div className="partners-slide">
              <a href="#" className="client-logo">
                <figure className="partners-slide-inner">
                  <img className="partners-slide-image" src="resources/images/brands/delhiberry.webp" alt="" />
                </figure>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> */}

    </div>
    </>
  )
}
